import { Component } from '@angular/core';
import { UserService, UserServiceState } from '../../../core/services/user.service';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-activation-success',
  imports: [RouterLink],
  templateUrl: './activation-success.html',
  styleUrl: './activation-success.scss',
})
export class ActivationSuccess {
  currentUser: UserServiceState | null = null;
  title: string = ''
  subTitle: string = ''
  constructor(private userService: UserService){
    this.userService.currentUser$.subscribe((data) => {
      this.currentUser = data;
      if(this.currentUser.valid){
        this.title = `¡Listo! Ya estás al aire`;
        this.subTitle = 'Tu registro fue un éxito.Ya puedes usar tu servicio como se debe.'
      }else{
        this.title = 'Ups no pudimos validar tus datos aún,'
        this.subTitle = 'pero puedes volver a intentarlo en 24 h. Mientras tanto, puedes usar nuestros servicios. #Virgin.'
      }
    })
  }
}
